import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const LanguageToggle = () => {
    const { i18n } = useTranslation();

    const currentLanguage = i18n.language; // 'en' or 'es'

    const toggleLanguage = () => {
        const nextLang = currentLanguage === 'en' ? 'es' : 'en';
        i18n.changeLanguage(nextLang);
    };

    return (
        <button
            onClick={toggleLanguage}
            className="relative flex items-center bg-gray-100 dark:bg-bg-tertiary rounded-full p-1 border border-gray-200 shadow-inner w-16 h-8 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-colors duration-300"
            aria-label="Toggle Language"
        >
            {/* Background Sliding Pill */}
            <motion.div
                className="absolute top-1 bottom-1 w-[28px] bg-primary rounded-full shadow-md z-0"
                initial={false}
                animate={{
                    left: currentLanguage === 'en' ? '4px' : '32px'
                }}
                transition={{ type: 'spring', stiffness: 500, damping: 30 }}
            />

            {/* Labels */}
            <div className="relative z-10 flex w-full justify-between items-center px-1 text-[10px] font-bold font-body">
                <span
                    className={`transition-colors duration-300 ${currentLanguage === 'en' ? 'text-white' : 'text-gray-400'
                        } ml-0.5`}
                >
                    EN
                </span>
                <span
                    className={`transition-colors duration-300 ${currentLanguage === 'es' ? 'text-white' : 'text-gray-400'
                        } mr-0.5`}
                >
                    ES
                </span>
            </div>
        </button>
    );
};

export default LanguageToggle;
